/**
 * Extract error message from Axios / network response
 * @param {any} error - The caught error object
 * @param {any} defaultMessage - Default fallback message
 * @returns {any} The extracted error message string
 */
export default function getErrorMessage(
  error: any,
  defaultMessage: string = 'Operation failed',
): string {
  if (!error) return defaultMessage;
  if (error.response) {
    const { data } = error.response;
    if (data) {
      if (typeof data === 'string') return data;
      if (data.statusMessage) return data.statusMessage;
      if (data.status_message) return data.status_message;
      if (data.message) return data.message;
      if (data.error) {
        if (typeof data.error === 'string') return data.error;
        if (data.error.message) return data.error.message;
      }
      return typeof data === 'object' ? JSON.stringify(data) : String(data);
    }
    if (error.response.statusText) {
      return `${error.response.status}: ${error.response.statusText}`;
    }
  }
  if (error.message) return error.message;
  return typeof error === 'string' ? error : defaultMessage;
}
